module.exports = __webpack_public_path__ + "static/media/servicio.d260f873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/tiendamia/servicio.png
// module id = 1194
// module chunks = 0